var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCostoEnvio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    style: {
      enableBackground: "new 0 0 62 62"
    },
    viewBox: "0 0 62 62",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 4,
    style: {
      fill: "#FC6E51"
    },
    width: 36,
    x: 21,
    y: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.7,13L9,13.2v-0.01v-0.76c0-1.97,1.44-3.65,3.39-3.95L21,7.15V13H10.7z",
    style: {
      fill: "#FC6E51"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 26,
    style: {
      fill: "#D3A06C"
    },
    width: 28,
    x: 23,
    y: 35
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,5v8H10.7L9,13.2c-1.13,0.25-2.19,0.76-3.11,1.49C4.06,16.15,3,18.36,3,20.7V31h54V5H21z",
    style: {
      fill: "#FF826E"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53,10v13.2c-0.64-0.13-1.31-0.2-2-0.2s-1.36,0.07-2,0.2V10c0-0.55,0.45-1,1-1h2     C52.55,9,53,9.45,53,10z",
    style: {
      fill: "#FC6E51"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45,25c-0.76,0.57-1.43,1.24-2,2h-1c-0.55,0-1-0.45-1-1V10c0-0.55,0.45-1,1-1h2c0.55,0,1,0.45,1,1     V25z",
    style: {
      fill: "#FC6E51"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M37,10v16c0,0.55-0.45,1-1,1h-2c-0.55,0-1-0.45-1-1V10c0-0.55,0.45-1,1-1h2C36.55,9,37,9.45,37,10     z",
    style: {
      fill: "#FC6E51"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29,10v16c0,0.55-0.45,1-1,1h-2c-0.55,0-1-0.45-1-1V10c0-0.55,0.45-1,1-1h2C28.55,9,29,9.45,29,10     z",
    style: {
      fill: "#FC6E51"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,17v6H7v-2.3c0-1.13,0.51-2.18,1.39-2.89C9.04,17.29,9.86,17,10.7,17H21z",
    style: {
      fill: "#69D6F4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "35,35 35,47 33,46 31,47 29,46 27,47 27,35    ",
    style: {
      fill: "#B27946"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.66,31c0.22,0.63,0.34,1.3,0.34,2s-0.12,1.37-0.34,2c-0.82,2.33-3.05,4-5.66,4     s-4.84-1.67-5.66-4C7.12,34.37,7,33.7,7,33s0.12-1.37,0.34-2c0.82-2.33,3.05-4,5.66-4S17.84,28.67,18.66,31z",
    style: {
      fill: "#969FAA"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57,25c2.43,1.83,4,4.73,4,8c0,5.52-4.48,10-10,10c-4.83,0-8.87-3.44-9.8-8     c-0.13-0.64-0.2-1.31-0.2-2s0.07-1.36,0.2-2c0.3-1.48,0.93-2.84,1.8-4c0.57-0.76,1.24-1.43,2-2c1.16-0.87,2.52-1.5,4-1.8     c0.64-0.13,1.31-0.2,2-0.2s1.36,0.07,2,0.2C54.48,23.5,55.84,24.13,57,25z",
    style: {
      fill: "#FCD770"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,31h20.2c-0.13,0.64-0.2,1.31-0.2,2s0.07,1.36,0.2,2H35h-8h-2.96H23h-4.34     c0.22-0.63,0.34-1.3,0.34-2s-0.12-1.37-0.34-2H21z",
    style: {
      fill: "#CCD1D9"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 33,
    r: 2,
    style: {
      fill: "#CCD1D9"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,33c0,0.7,0.12,1.37,0.34,2H2c-0.55,0-1-0.45-1-1v-2c0-0.55,0.45-1,1-1h1h4.34     C7.12,31.63,7,32.3,7,33z",
    style: {
      fill: "#CCD1D9"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,30h2c0.552,0,1,0.449,1,1h2c0-1.654-1.346-3-3-3v-2h-2v2c-1.654,0-3,1.346-3,3s1.346,3,3,3h2c0.552,0,1,0.449,1,1    s-0.448,1-1,1h-2c-0.552,0-1-0.449-1-1h-2c0,1.654,1.346,3,3,3v2h2v-2c1.654,0,3-1.346,3-3s-1.346-3-3-3h-2c-0.552,0-1-0.449-1-1    S49.448,30,50,30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,33c0-3.408-1.559-6.459-4-8.479V0H20v6.296L12.239,7.49C9.783,7.868,8,9.946,8,12.432v0.006    c-0.986,0.323-1.917,0.815-2.734,1.469C3.19,15.567,2,18.044,2,20.702V30c-1.103,0-2,0.897-2,2v2c0,1.103,0.897,2,2,2h4.685    c1.126,2.361,3.53,4,6.315,4s5.188-1.639,6.315-4H22v26h30V43.949C57.598,43.442,62,38.728,62,33z M54,22.426V10    c0-1.103-0.897-2-2-2h-2c-1.103,0-2,0.897-2,2v12.426c-0.698,0.198-1.366,0.463-2,0.788V10c0-1.103-0.897-2-2-2h-2    c-1.103,0-2,0.897-2,2v16c0,0.849,0.534,1.571,1.281,1.861c-0.358,0.674-0.642,1.391-0.855,2.139H22V6h34v17.214    C55.366,22.889,54.698,22.625,54,22.426z M52,22.051C51.67,22.021,51.338,22,51,22s-0.67,0.021-1,0.051V10h2V22.051z M42.521,26    H42V10h2v14.521C43.462,24.967,42.967,25.462,42.521,26z M20,22H8v-1.298c0-0.825,0.37-1.594,1.015-2.11    C9.491,18.21,10.09,18,10.701,18H20V22z M56,2v2H22V2H56z M12.544,9.466L20,8.319V12h-9.299c-0.222,0-0.444,0.011-0.665,0.029    C10.21,10.722,11.205,9.672,12.544,9.466z M4,20.702c0-2.047,0.917-3.954,2.516-5.233C7.699,14.521,9.186,14,10.701,14H20v2    h-9.299c-1.063,0-2.106,0.366-2.937,1.03C6.644,17.928,6,19.266,6,20.702V24h14v6h-0.685c-1.126-2.361-3.53-4-6.315-4    s-5.188,1.639-6.315,4H4V20.702z M2,34v-2h4.08C6.033,32.328,6,32.66,6,33s0.033,0.672,0.08,1H2z M13,38c-2.757,0-5-2.243-5-5    s2.243-5,5-5s5,2.243,5,5S15.757,38,13,38z M19.92,34c0.047-0.328,0.08-0.66,0.08-1s-0.033-0.672-0.08-1h20.13    C40.021,32.33,40,32.662,40,33s0.021,0.67,0.051,1H24.039H22H19.92z M28,36h6v9.382l-1-0.5l-2,1l-2-1l-1,0.5V36z M24,60V36h0.039    H26v12.618l3-1.5l2,1l2-1l3,1.5V36h4.426c0.699,2.458,2.228,4.566,4.269,6H38v2h12v16H24z M51,42c-4.963,0-9-4.038-9-9    s4.037-9,9-9s9,4.038,9,9S55.963,42,51,42z"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 38,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 6,
    x: 42,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 42,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 46,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 38,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    width: 2,
    x: 38,
    y: 38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,30c-1.654,0-3,1.346-3,3s1.346,3,3,3s3-1.346,3-3S14.654,30,13,30z M13,34c-0.552,0-1-0.449-1-1s0.448-1,1-1    s1,0.449,1,1S13.552,34,13,34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,8h-2c-1.103,0-2,0.897-2,2v16c0,1.103,0.897,2,2,2h2c1.103,0,2-0.897,2-2V10C30,8.897,29.103,8,28,8z M26,26V10h2    l0.001,16H26z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,8h-2c-1.103,0-2,0.897-2,2v16c0,1.103,0.897,2,2,2h2c1.103,0,2-0.897,2-2V10C38,8.897,37.103,8,36,8z M34,26V10h2    l0.001,16H34z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostoEnvio);
export default __webpack_public_path__ + "static/media/costo_envio.1209ffbf4b0a56834b42aaa8ad85f9fa.svg";
export { ForwardRef as ReactComponent };